<template><!--面包屑-->
  <el-breadcrumb separator="/">
    <el-breadcrumb-item v-for="v in list" :key="v.path" v-if="v.meta.title!='首页'">{{v.meta.title}}</el-breadcrumb-item>
<!--    <el-breadcrumb-item v-for="v in list" :key="v.path" :to="v.path">{{v.meta.title}}</el-breadcrumb-item>-->
  </el-breadcrumb>
</template>

<script>
  export default {
    name: "Breadcrumb",
    data() {
      return {
        list: []
      }
    },
    methods: {
      getBreadcrumb(matched) {
        if (matched.length && matched[1].path == '/welcome') {
          matched = matched.splice(0, 1)
        }
        this.list = matched;
      }
    },
    watch: {
      $route(to, from) {
        // console.log(to.matched)
        // this.list=to.matched
        this.getBreadcrumb(to.matched);
      }
    },
    mounted() {
      // this.list=this.$route.matched;
      this.getBreadcrumb(this.$route.matched);
      // console.log(this.list)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Breadcrumb.vue